import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogIn, Lock, Mail, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("tsv_token", data.access_token);
      localStorage.setItem("tsv_admin_email", data.email);
      toast.success("Access granted. Welcome back.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-20" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/40 to-black" />

      <Link
        to="/"
        data-testid="admin-back-link"
        className="absolute top-8 left-8 font-mono text-xs uppercase tracking-widest text-white/40 hover:text-neon-cyan flex items-center gap-2 transition-colors"
      >
        <ArrowLeft size={14} /> Back to site
      </Link>

      <div className="glass-strong w-full max-w-md p-10 relative">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-neon-cyan to-transparent" />

        <div className="overline mb-4">// SECURE_CHANNEL</div>
        <h1 className="font-heading font-black text-3xl tracking-tighter mb-2">
          Admin <span className="text-neon-cyan">Access</span>
        </h1>
        <p className="text-white/50 text-sm mb-8">Authorized personnel only.</p>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="overline block mb-2">// Email</label>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="username"
                data-testid="admin-email-input"
                className="tsv-input !pl-10"
                placeholder="admin@techsavvypreneurs.com"
              />
            </div>
          </div>
          <div>
            <label className="overline block mb-2">// Password</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                data-testid="admin-password-input"
                className="tsv-input !pl-10"
                placeholder="••••••••"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="btn-primary w-full justify-center disabled:opacity-50"
          >
            {loading ? "Authenticating…" : "Enter Dashboard"} <LogIn size={14} />
          </button>
        </form>

        <div className="mt-8 pt-6 border-t border-white/10 font-mono text-[10px] uppercase tracking-widest text-white/30 text-center">
          Encrypted · JWT · Session-based
        </div>
      </div>
    </div>
  );
}
